module.exports = __webpack_public_path__ + "img/35.75cdcd16.jpg";